import { Settings } from '../Settings.js';
import { frameBudgetExhausted } from './FrameBudget.js';

let pendingExplosions = [];
let pendingIndex = 0;
const denseBlastAreas = [];

export const hasDenseBlastNear = (point, radius) => {
	for(const area of denseBlastAreas){
		const dx = point.x - area.x;
		const dy = point.y - area.y;
		const mergeRadius = Math.min(radius, area.radius) * 0.25;
		if(dx * dx + dy * dy <= mergeRadius * mergeRadius) return true;
	}
	return false;
};

export const rememberDenseBlast = (point, radius) => {
	if(hasDenseBlastNear(point, radius)) return false;
	denseBlastAreas.push({ x: point.x, y: point.y, radius });
	return true;
};

export const queueExplosion = explosive => {
	if(!explosive || explosive.destroyed || explosive.exploded || explosive.explosionQueued) return false;

	explosive.explosionQueued = true;
	pendingExplosions.push(explosive);
	return true;
};

export const update = () => {
	const startTime = performance.now();
	let processed = 0;
	let examined = 0;

	while(pendingIndex < pendingExplosions.length && processed < Settings.maxExplosionsPerFrame){
		if(frameBudgetExhausted('explosions', startTime, Settings.maxExplosionProcessingTimeMS, examined)) break;

		const explosive = pendingExplosions[pendingIndex++];
		examined++;
		explosive.explosionQueued = false;
		if(explosive.destroyed || explosive.exploded) continue;

		explosive.performExplosion();
		processed++;
	}

	if(pendingIndex >= pendingExplosions.length){
		pendingExplosions.length = 0;
		pendingIndex = 0;
		denseBlastAreas.length = 0;
	}else if(pendingIndex > 256){
		pendingExplosions = pendingExplosions.slice(pendingIndex);
		pendingIndex = 0;
	}

	return processed;
};

export const reset = () => {
	for(let i = pendingIndex; i < pendingExplosions.length; i++){
		pendingExplosions[i].explosionQueued = false;
	}
	pendingExplosions.length = 0;
	pendingIndex = 0;
	denseBlastAreas.length = 0;
};

export const getPendingExplosionCount = () => pendingExplosions.length - pendingIndex;
